import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PopinService} from '../services/popin.service';
import {PopinOneComponent} from '../popin-one/popin-one.component';

@Component({
  selector: 'app-popin-three',
  templateUrl: './popin-three.component.html',
  styleUrls: ['./popin-three.component.scss']
})
export class PopinThreeComponent implements OnInit {

  public visitRandomId: string;
  public uri: string;
  public customerName: string;
  public productId: string;
  public customerCity: string;
  public customerActivity: string;

  constructor(private popinService: PopinService,
              private router: Router,
              private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.visitRandomId = PopinOneComponent.visitRandomId;
    this.uri = encodeURIComponent(PopinOneComponent.uri);
    this.customerName = PopinOneComponent.customer.RaisonSociale;
    this.productId = this.route.snapshot.params['product'];
    this.customerCity = PopinOneComponent.customer.Ville;
    this.customerActivity = PopinOneComponent.customer.LibelleNAF;
  }

}
